  (function($) {
  
  })();
(function($) {
  $(document).ready(function() {
    rv.init();
  });
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  var body_event = $("body");
  body_event.on("click", ".theme-layout-version" , function(){
    $(this).toggleClass('dark');
    $('body').removeClass('dark');
    if($('.theme-layout-version').hasClass('dark')){
      $('.theme-layout-version').text('White');
      $('body').addClass('dark');
    }else{
      $('#theme-dark').remove();
      $('.theme-layout-version').text('Black');
    }

    return false;
  });

  
  var rv = {
    init: function() {
      this.HeaderSearchForm();
      this.Ajaxwish();
      this.color();
    },

    color : function() {
//       $('<div class="sidebar-btn dark-light-btn">' +
//         '<div class="dark-light">'+
//         '<div class="theme-layout-version">Black' +
//         '</div>' +
//         '</div>' +
//         '</div>').appendTo($('body'));
    },
    
    Ajaxwish : function(id, quantity, modal) {
      $('body').on('click', '.addtowish-item-js', function(e) { 
        var product_handle = $(this).attr('id'); 
        rv.addTowish(e, product_handle);
      });
    },

    addTowish : function (e, product_handle)
    {
      var _this = $(this);
      e.preventDefault();
      var product_handlers = getCookie("wish_productids");
      
      _this.addClass('loading');
      var objhandler = product_handlers.toString().split("$$");
      var IsCookie = false;

      for(var i = 0; i < objhandler.length - 1 ;i++)
        if(objhandler[i] == product_handle)
        {
          IsCookie = true;
          break;
        }
        if(!IsCookie){
         document.cookie = "wish_productids ="+ product_handlers + product_handle + "$$" + ";path=/;expires=" ;
       }
       _this.removeClass('loading');

     },

     HeaderSearchForm: function() {
      var ajaxRequest = null;
      var form = $('.jas-header-search form');
      $("#search-input").keyup(function(){
        var searchResult = $("#search-result-print");
        var term = $('#search-input').val();
        if(term != ""){

          var searchURL = "/search?type=product,article,page&q=" + term + '*' + "&ajax=true";
          document.cookie = "search_using_ajax = true";
          form.addClass('loading')
          autocomplete ="off",
          ajaxRequest != null && ajaxRequest.abort(), ajaxRequest = $.get(searchURL + "&view=json", function(data) {
            searchResult.html($(data).find("#ajax_search").html());


          }).always(function() {
            form.removeClass('loading');
            document.cookie = "search_using_ajax = false";
          })
        }
        $('body').bind('click', function() {
          form.removeClass('loading');
        })
      });
    },
  }
  $('body').on('click', '.addtowish-item-js', function(e){
    e.preventDefault();

    var product_handle = $(this).attr('id');
    rv.addTowish(e, product_handle);
      // modalcompare_product();
      // $("#modalcompare").modal();
    })
})(jQuery);

$(document).ready(function() {
  "use strict";
  setSlickGallery($('.carousel-menu-1'), 5, 5, 4, 3, 2, 'carousel');
  $(window).trigger('resize');
  setTimeout(function(){
    $("#pageContent").addClass("show");
    $(".breadcrumbs").length && $(".breadcrumbs").addClass("show");
  }, 0);
});

function setSlickGallery(value) {
  if (value.length == 0) return false;
  var arr = $.makeArray(arguments);
  var fn = window[arr[arr.length - 1]];
  if (typeof fn === "function") fn(arr[0], arr[1], arr[2], arr[3], arr[4], arr[5]);
}
//=========== header menu(hover)
(function toggle_header_menu() {
  var timeout1 = false;

  var set_dropdown_maxH = function() {
    var wind_H = window.innerHeight,
    $menu = $(this).find('.dropdown-menu'),
    menu_top = $menu.get(0).getBoundingClientRect().top,
    menu_max_H = wind_H - menu_top,
    $menu_H = $menu.innerHeight(),
    $btn_top = $('.back-to-top');

    if ($menu_H > menu_max_H) {
      var $body = $('body'),
      $stuck = $('.stuck-nav');
      $menu.css({
        maxHeight: menu_max_H - 100,
        overflow: 'auto'
      });

      var scrollWidth = function() {
        var $div = $('<div>').css({
          overflowY: 'scroll',
          width: '50px',
          height: '50px',
          visibility: 'hidden'
        });
        var scrollWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
        return scrollWidth;
      };

      $body.css({
      });

      $stuck.css({
      });

      $btn_top.css({
      });
    }
  };

  if ($('.nav-megamenu, .menu-vertical nav').length > 0) {
    $(document).on({
      mouseenter: function() {
        var $this = $(this),
        that = this;
        timeout1 = setTimeout(function () {
          var $carousel = $this.find('.carousel-menu-1.header-menu-product'),
          $menu = $this.find('.dropdown-menu');
          $this.find(".dropdown-menu")
          .stop();
          if($menu.length & !$menu.hasClass('one-col')) {
            set_dropdown_maxH.call(that);
          }

          if($carousel.length) {
            if(!$carousel.hasClass('slick-initialized')) {
              setSlickGallery($carousel, 2, 2, 2, 2, 2, 'carousel');
            } else {
              $carousel.slick('setPosition');
            }
            var obgCarusel = $('.nav-megamenu .header-menu-product');
            if(obgCarusel.length){
              var widthCarusel = obgCarusel.parent().width();
              var widthCarusel = widthCarusel - 8;
              obgCarusel.css({
                width: widthCarusel
              });
            }
          }

        });
      },
      mouseleave: function(e) {
        var $this = $(this),
        $dropdown = $this.find(".dropdown-menu");
        if($(e.target).parents('.dropdown-menu').length && !$(e.target).parents('.megamenu-submenu').length && !$(e.target).parents('.one-col').length) return;

        if(timeout1 !== false) {
          clearTimeout(timeout1);
          timeout1 = false;
        }

        if($dropdown.length) {
          $dropdown.stop().fadeOut({duration: 0, complete: function() {
            $this.find(".dropdown-menu");
          }});
        } else {
          $this.find(".dropdown-menu");
        }

        $dropdown.removeAttr('style');

        $('body').removeAttr('style');
      }
    }, '.nav-megamenu li, .menu-vertical nav li');

    $('.multicolumn ul li').hover(function() {
      var $ul = $(this).find('ul:first');

      if ($ul.length) {
        var windW = window.innerWidth,
        windH = window.innerHeight,
        ulW = parseInt($ul.css('width')),
        thisR = this.getBoundingClientRect().right,
        thisL = this.getBoundingClientRect().left;

        if (windW - thisR < ulW) {
          $ul.removeClass('left').addClass('right');
        } else if (thisL < ulW) {
          $ul.removeClass('right').addClass('left');
        } else {
          $ul.removeClass('left right');
        }
        $ul.stop(true, true).fadeIn(300);

      }
    }, function() {
      $(this).find('ul:first').stop(true, true).fadeOut(300).removeAttr('style');
    });

    $('.megamenu-submenu li').hover(function() {
      var $ul = $(this).find('ul:first');

      if ($ul.length) {
        var $dropdownMenu = $(this).parents('.nav-megamenu').find('.dropdown-menu'),
        dropdown_left = $dropdownMenu.get(0).getBoundingClientRect().left,
        dropdown_Right = $dropdownMenu.get(0).getBoundingClientRect().right,
        dropdown_Bottom = $dropdownMenu.get(0).getBoundingClientRect().bottom,
        ulW = parseInt($ul.css('width')),
        thisR = this.getBoundingClientRect().right,
        thisL = this.getBoundingClientRect().left;

        if (dropdown_Right - 20 - thisR < ulW) {
          $ul.removeClass('left').addClass('right');
        } else if (thisL - ulW - 20 < dropdown_left) {
          $ul.removeClass('right').addClass('left');
        } else {
          $ul.removeClass('left right');
        }

        $ul.stop(true, true).fadeIn(300);

        var ul_bottom = $ul.get(0).getBoundingClientRect().bottom;

        if (dropdown_Bottom < ul_bottom) {
          var move_top = dropdown_Bottom - ul_bottom;
          $ul.css({
            top: move_top
          });
        }
      }
    }, function() {
      $(this).find('ul:first').stop(true, true).fadeOut(300).removeAttr('style');
    });

    $('.megamenu div').hover(function() {
      $(this).children('.title-underline').addClass('active');
    }, function() {
      $(this).children('.title-underline').removeClass('active');
    });
  }
  if ($('.menu-vertical nav').length > 0) {
    $('.menu-vertical nav li:not(.multicolumn)').hover(function() {
      var $this = $(this);
      var menuVerticalHeight = $('.menu-vertical').innerHeight();
      var menuVerticalPopupHeight = $(this).find('.dropdown-menu').innerHeight();
      if( menuVerticalHeight >= menuVerticalPopupHeight ){
        $(this).find('.dropdown-menu').css({
          'minHeight' : menuVerticalHeight
        });
      };
    }, function() {
      $(this).find('.dropdown-menu').removeAttr('style');
    });    
  }

  function onscroll_dropdown_hover() {
    var $dropdown_active = $('.dropdown.hover');
    if (!$dropdown_active.find('.dropdown-menu').not('.one-col').length) return;
    if ($dropdown_active.length)
      set_dropdown_maxH.call($dropdown_active);
  };
  $(window).on('scroll', function() {
    onscroll_dropdown_hover();
  });
})();